<template><div></div></template>
<script>
export default {
  name: 'sidebar-form'
}
</script>
